import React from 'react';
import { DisplayText, TextStyle } from '@superops/ui-design-system';
import { isEmpty } from 'lodash';
import { Logo } from '@nile/components';
import envConfig from '@nile/home/src/Config/env';
import { FormattedMessage } from 'react-intl';
import { changeTimeFormat } from '@nile/reports/src/modules/EfficiencyReport/util';

function NumberCard(props) {
  const { data, chart } = props;

  if (isEmpty(data)) {
    return (
      <div className="flex-center full-height mb20">
        <div className="flex-center fcol">
          <Logo
            url={`${envConfig.imageRoot}svg/chartEmpty.svg`}
            height="70px"
            width="70px"
          />
          <div className="flex-center">
            <TextStyle variation="subdued">
              <FormattedMessage id="reports.chart.data.empty" />
            </TextStyle>
          </div>
        </div>
      </div>
    );
  }
  const getValue = (val, unit) => {
    const { days, hours, minutes } = changeTimeFormat(val, unit);
    return `${(days && `${days}d`) || ''}  ${(hours && `${hours}h`) ||
      ''}  ${(minutes && `${minutes}m`) || ''}`;
  };
  return (
    <div className="flex fcol mb20">
      {data?.map((el) => (
        <>
          <div className="flex mb10">
            <TextStyle>
              <FormattedMessage id={chart?.name} />
            </TextStyle>
          </div>
          <div className="flex">
            {el?.value ? (
              <DisplayText element="h2" weight="SemiBold">
                {chart?.internalName?.includes('TIME_SPENT')
                  ? getValue(el?.value, el?.metricUnit)
                  : el?.value}
              </DisplayText>
            ) : (
              <TextStyle variation="subdued">
                <FormattedMessage id="app.noData.message" />
              </TextStyle>
            )}
          </div>
        </>
      ))}
    </div>
  );
}

export default NumberCard;
